var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm._f("language")('Notes')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.language === 'english' ? _vm.property.str_highlights_en : _vm.property.str_highlights_jp)}})])}
var staticRenderFns = []

export { render, staticRenderFns }